export default "__VITE_ASSET__1c8d1810__"